import { styled } from '@mui/system';

export const GridSection = styled('section')`
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(113, 110, 106, 0.4);
  background-color: white;
`;
